function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import LoadingButton from "../../../LoadingButton";
import { getBankStatus, getKYCStatus } from "../../../../../utils/helpers";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SixthStep = function SixthStep(_ref) {
  var setStep = _ref.setStep,
    winnreAuth = _ref.winnreAuth;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    kycStatus = _useState4[0],
    setKycStatus = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    bankStatus = _useState6[0],
    setBankStatus = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    kycRetryCount = _useState8[0],
    setKycRetryCount = _useState8[1];
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    bankRetryCount = _useState0[0],
    setBankRetryCount = _useState0[1];
  var checkKYCStatus = function checkKYCStatus() {
    return getKYCStatus({
      winnreAuth: winnreAuth
    }).then(function (res) {
      console.log("Returned from getKYCStatus:", res);
      setKycStatus(res === null || res === void 0 ? void 0 : res.message);
    })["catch"](function (error) {
      return console.error("Error fetching KYC status:", error);
    });
  };
  var checkBankStatus = function checkBankStatus() {
    return getBankStatus({
      winnreAuth: winnreAuth
    }).then(function (res) {
      console.log("Returned from getBanktatus:", res);
      setBankStatus(res === null || res === void 0 ? void 0 : res.message);
    })["catch"](function (error) {
      return console.error("Error fetching Bank status:", error);
    });
  };
  useEffect(function () {
    console.log("U1");
    if (kycStatus !== "COMPLETED" && kycRetryCount < 4) {
      var kycIntervalId = setInterval(function () {
        checkKYCStatus();
        setKycRetryCount(function (prev) {
          return prev + 1;
        });
      }, 60000);
      checkKYCStatus(); // Call immediately on mount
      return function () {
        return clearInterval(kycIntervalId);
      };
    }
  }, [kycStatus, kycRetryCount]);
  useEffect(function () {
    console.log("U2");
    if (kycStatus === "COMPLETED" && bankStatus !== "COMPLETED" && bankRetryCount < 4) {
      var bankIntervalId = setInterval(function () {
        checkBankStatus();
        setBankRetryCount(function (prev) {
          return prev + 1;
        });
        // if(bankRetryCount=== 3){
        //     setBankStatus('COMPLETED');
        // }
      }, 60000);
      checkBankStatus();
      return function () {
        return clearInterval(bankIntervalId);
      };
    }
  }, [kycStatus, bankStatus, bankRetryCount]);
  useEffect(function () {
    console.log("U3");
    if (kycStatus === "COMPLETED" && bankStatus === "COMPLETED") {
      setLoading(false);
      setStep(3);
    }
  }, [kycStatus, bankStatus]);
  var displayErrorMessage = kycRetryCount >= 4 && kycStatus !== "COMPLETED" || bankRetryCount >= 4 && bankStatus !== "COMPLETED";
  console.log("kycRetry", kycRetryCount);
  console.log("bankRetry", bankRetryCount);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col justify-center items-center py-3",
    children: [loading && !displayErrorMessage && /*#__PURE__*/_jsxs(_Fragment, {
      children: [" ", /*#__PURE__*/_jsxs("div", {
        className: "mt-2",
        children: [/*#__PURE__*/_jsx(LoadingButton, {
          hideButton: true,
          loading: true
        }), " "]
      }), /*#__PURE__*/_jsx("h3", {
        className: " mt-2 font-semibold text-center",
        children: "Fetching your documents. This might take a few minutes."
      }), /*#__PURE__*/_jsx("h3", {
        className: "mt-2 font-semibold text-center",
        children: "Thank you for your patience."
      })]
    }), displayErrorMessage && /*#__PURE__*/_jsxs("div", {
      className: " py-3 flex flex-col justify-center items-center",
      children: [/*#__PURE__*/_jsx("h3", {
        className: " mt-2 font-semibold text-center text-red-500",
        children: "We\u2019re unable to complete the verification at this time."
      }), /*#__PURE__*/_jsx("h3", {
        className: "mt-2 font-semibold text-center text-red-500",
        children: "Please try again later."
      })]
    })]
  });
};
export default SixthStep;